import { render, staticRenderFns } from "./ourService-4-Nav.vue?vue&type=template&id=022f1997"
import script from "./ourService-4-Nav.vue?vue&type=script&lang=js"
export * from "./ourService-4-Nav.vue?vue&type=script&lang=js"
import style0 from "./ourService-4-Nav.vue?vue&type=style&index=0&id=022f1997&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports